<!-- 客户余额调整查询 -->
<template>
  <div class="adjustmentList">
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-toolbar>
        <template v-slot:buttons>
          <template v-for="item in menuButtonList">
            <vxe-button
              type="primary"
              :icon="item.attributes.buttonStyle"
              :style="
                'background-color:' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)') +
                ';border:1px solid ' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)')
              "
              :key="item.id"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        :row-id="'docNo'"
        show-header-overflow
        highlight-current-row
        highlight-hover-row
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        column-min-width="120"
        :max-height="$store.state.app.tableHeight"
        :loading="load"
        :auto-resize="true"
        :data="tableData"
        :columns="columnList"
        @cell-dblclick="dblclickEvent"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
      >
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/customerBalance/customerBalance';
  import DataBaseAPI from '@/api/dataBase';
  import SiruiSearch from '@/components/SiruiSearch';
  export default {
    name: 'adjustmentList',
    components: {
      SiruiSearch,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      searchColumns() {
        return [
          {
            //公司代码
            prop: 'businessCompanyCode',
            name: this.$t('customerBalanceAdjust.search.businessCompanyName'),
            type: 'select',
            options: this.companyList,
            changeMethod: 'companyChange',
            filterable: true,
          },
          {
            //客户名称
            prop: 'customer',
            type: 'searchTableSpec',
            name: this.$t('customerBalanceAdjust.search.partnerName'),
            searchType: 'supplier',
            extraData: {
              partnerTypes: 'HZHB03,HZHB01',
              requestStatus: 'ZT03',
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            isNeedMultipleValue: true,
          },
          {
            //单据编号
            prop: 'docNo',
            name: this.$t('customerBalanceAdjust.search.docNo'),
            type: 'input',
            maxlength: 30,
          },
          {
            //余额类型
            prop: 'balanceType',
            name: this.$t('customerBalanceAdjust.search.balanceType'),
            type: 'dict',
            dictType: 'balance_type',
          },
          {
            //单据状态
            prop: 'docStatus',
            name: this.$t('customerBalanceAdjust.search.docStatus'),
            type: 'dict',
            dictType: 'customer_balance_status',
          },
          {
            //制单人
            prop: 'operaterName',
            name: this.$t('customerBalanceAdjust.search.operaterName'),
            type: 'input',
            maxlength: 30,
          },
          {
            // 制单日期从
            prop: 'operaterDateStart',
            name: this.$t('customerBalanceAdjust.search.operaterStartDate'),
            type: 'startDaterangePicker',
          },
          {
            // 制单日期至
            prop: 'operaterDateEnd',
            name: this.$t('customerBalanceAdjust.search.operaterEndDate'),
            type: 'endDaterangePicker',
          },
          {
            // 生效日期从
            prop: 'effectiveDateStart',
            name: this.$t('customerBalanceAdjust.search.effectiveStartDate'),
            type: 'startDaterangePicker',
          },
          {
            // 生效日期至
            prop: 'effectiveDateEnd',
            name: this.$t('customerBalanceAdjust.search.effectiveEndDate'),
            type: 'endDaterangePicker',
          },
        ];
      },
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            type: 'seq',
            title: this.$t('table.index'),
            visible: true,
            width: '80',
          },
          {
            // 公司名称
            field: 'businessCompanyName',
            title: this.$t('customerBalanceAdjust.table.businessCompanyName'),
          },
          {
            // 单据编号
            field: 'docNo',
            title: this.$t('customerBalanceAdjust.table.docNo'),
          },
          {
            // 制单人
            field: 'operaterName',
            title: this.$t('customerBalanceAdjust.table.operaterName'),
          },
          {
            // 制单日期
            field: 'operaterDate',
            title: this.$t('customerBalanceAdjust.table.operaterDate'),
          },
          {
            // 单据状态
            field: 'docStatus',
            title: this.$t('customerBalanceAdjust.table.docStatus'),
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('customer_balance_status'),
              props: {
                clearable: true,
              },
            },
          },
          {
            // 生效日期
            field: 'effectiveDate',
            title: this.$t('customerBalanceAdjust.table.effectiveDate'),
          },
          {
            // 余额类型
            field: 'balanceType',
            title: this.$t('customerBalanceAdjust.table.balanceType'),
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('balance_type'),
              props: {
                clearable: true,
              },
            },
          },
          {
            // 客户名称
            field: 'partnerName',
            title: this.$t('customerBalanceAdjust.table.partnerName'),
          },
          {
            // 调整额
            field: 'adjustAmount',
            title: this.$t('customerBalanceAdjust.table.adjustAmount'),
          },
          {
            // 备注
            field: 'remark',
            title: this.$t('customerBalanceAdjust.table.remark'),
          },
        ];
      },
    },
    data() {
      return {
        menuButtonList: [], // 按钮
        load: false,
        tableData: [],
        multipleSelection: [],
        companyList: [],
        query: {
          businessCompanyCode: null, // 公司代码
          businessCompanyName: null, // 公司
          docStatus: null, // 单据状态
          partnerCodes: null, // 合作伙伴编码
          partnerName: null, // 合作伙伴名称
          docNo: null, // 单据编号
          balanceType: null, // 余额类型
          operaterNo: null, // 制单人编号
          operaterName: null, // 制单人
          operaterDateStart: null, // 日期从
          operaterDateEnd: null, // 日期至
          effectiveDateStart: null, // 日期从
          effectiveDateEnd: null, // 日期至
        },
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
        heightNew: 0,
      };
    },
    activated() {
      if (!this.$route.meta.isBack) {
        // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
        this.getData();
      }
      // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
      this.$route.meta.isBack = false;
    },
    mounted() {
      this.getData();
      this.getCompany();
      this.getButtonList();
      this.heightNew = document.body.clientHeight - 300 + 'px';
    },
    methods: {
      async getData() {
        this.load = true;
        const { pageNum, pageSize } = this.page;
        if (this.query.customer) {
          this.query.partnerCodes = this.query.customer.map((item) => item.partnerCode);
          delete this.query.customer;
        } else {
          this.query.partnerCodes = null;
        }
        const params = { ...this.query, pageNum, pageSize };
        let res = await this.$axios.post(API.QUERY_CUSTOMERBALANCEADJUST_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code == 0) {
            this.tableData = res.data.data.records;
            this.page.total = res.data.data.total;
          }
        }
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      chooseClick(type) {
        if (type == 'add') {
          this.handleAdd();
        } else if (type == 'edit') {
          this.handleEdit();
        } else if (type === 'export') {
          //导出
          this.export();
        }
      },
      handleAdd() {
        let path = {
          path: '/customerBalance/adjustmentAdd',
          name: 'adjustmentAdd',
          meta: {
            keepAlive: true,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      handleEdit() {
        // 编辑
        if (this.multipleSelection.length === 0) {
          this.tips('noSelectDel');
        } else if (this.multipleSelection.length > 1) {
          this.tips('onlyCanSelectNoEdit');
        } else if (
          this.multipleSelection.length === 1 &&
          !(this.multipleSelection[0].docStatus == 0)
        ) {
          this.tips('typeSelectEdit');
        } else {
          this.toPath('adjustmentEdit', { id: this.multipleSelection[0].id });
        }
      },
      //导出
      export() {
        let selectedList = this.$refs.table.getCheckboxRecords(); // 历史选中数据
        const params = this.$refs.siruiSearch.query;
        params.ids = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.ids.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.ids.push(item.id);
          });
        }
        // 获取数据
        this.$axios.post(API.EXPORT_APPLICATION_API, params).then((res) => {
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },

      getButtonList() {
        //获取菜单按钮
        this.getButtons().then((res) => {
          this.menuButtonList = res;
          // this.menuButtonList.splice(this.menuButtonList.findIndex(e => e.attributes.buttonUrl === 'edit'),1);
        });
      },
      handleSelectionChange(val) {
        // 选中事件
        this.multipleSelection = val.selection;
      },
      dblclickEvent(value) {
        // 列表双击
        this.toPath('adjustmentDetail', { id: value.row.id });
      },
      searchBtnClick() {
        this.resetBtnClick();
      },
      resetBtnClick() {
        // 重置
        this.page.pages = 0;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.multipleSelection = [];
        this.$refs.table.clearCheckboxReserve();
        this.getData();
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
      exportChildData() {
        // 返回数据
        const [...tableData] = this.$refs.table.getTableData().fullData;
        return new Promise((resolve) => {
          this.$refs.table.validate().then(() => {
            resolve(tableData);
          });
        });
      },
      // 提示
      tips(info) {
        this.$message({
          showClose: true,
          message: this.$t(`customerBalanceAdjust.msg.${info}`),
          type: 'error',
        });
      },
      toPath(name, query) {
        // 跳转路径
        let path = {
          path: `/customerBalance/${name}`,
          name: name,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
